import { Link, createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { AuthLayout, safeRedirect } from '@/features/auth/auth-layout';
import { SignUpForm } from '@/features/auth/forms';
import { meQuery } from '@/lib/queries';

export const Route = createFileRoute('/signup')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (me) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: SignUpPage,
});

function SignUpPage() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const target = safeRedirect(search.redirect);
  return (
    <AuthLayout
      title="Create your Regent account"
      subtitle="One place for tasks, docs, chat and everything else."
      footer={
        <>
          Already have an account?{' '}
          <Link to="/login" search={search} className="font-medium text-accent-text hover:underline">
            Sign in
          </Link>
        </>
      }
    >
      <SignUpForm redirectTo={target} onDone={() => void navigate({ href: target })} />
    </AuthLayout>
  );
}
